import { createContext, useContext } from "react"
import type { RadioListContextValue } from "./types"

export const RadioListContext = createContext<RadioListContextValue>({})
export const useRadioListContext = () => useContext(RadioListContext)
